import { collections } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function CollectionIndex() {
  return (
    <section id="collections" className="border-b border-background-200 bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <SectionHeading
              index="02"
              eyebrow="Collection Index"
              title="精选合集索引：四册主档案"
              desc="把零散线索收进固定档案，是本站最常用的一级入口。每册都有独立的编号、归档数与标签体系，可长期追踪更新。"
            />
          </Reveal>
          <Reveal delay={120}>
            <a
              href="#keywords"
              className="inline-flex h-10 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-list-check-2" />
              全部归档目录
            </a>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {collections.map((item, index) => (
            <Reveal key={item.id} delay={index * 100}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} · 黑料反差合集封面`}
                    title={`${item.title} · 黑料反差实锤归档`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
                  <span className="absolute left-3 top-3 rounded bg-foreground-950/80 px-2 py-1 font-label text-[11px] text-background-100">
                    {item.id}
                  </span>
                  <span className="absolute bottom-3 right-3 rounded bg-accent-500 px-2 py-1 font-label text-[11px] text-foreground-950">
                    {item.count} 条
                  </span>
                </div>

                <div className="flex flex-1 flex-col gap-3 p-5">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <div className="mt-auto flex flex-wrap gap-2 pt-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}